// Згенеровано Tools/gen_frontend.py з визначень модулів. Не редагувати вручну: зміни моделі — у визначенні модуля
// Solutions/Metadata/<Група>/<Модуль>/module.definition.json (каталог Design — похідний), власні подання — у views/ пакета.

import type { IRecordTypeDefinition } from '@platform/core/types';
import { assembleViewSet } from '@platform/core/lib/assembleViewSet';
import meetingParticipantEntity from './entities/meeting-participant.json';
import meetingParticipantMenu from '../pages/meeting-participant/menu.json';
import meetingParticipantFullForm from '../pages/meeting-participant/forms/full.json';
import meetingParticipantContextForm from '../pages/meeting-participant/forms/context.json';
import meetingParticipantMiniForm from '../pages/meeting-participant/forms/mini.json';
import meetingParticipantLookupForm from '../pages/meeting-participant/forms/lookup.json';
import meetingParticipantTableView from '../pages/meeting-participant/views/table.json';
import meetingParticipantCardsView from '../pages/meeting-participant/views/cards.json';
import meetingParticipantCalendarView from '../pages/meeting-participant/views/calendar.json';
import meetingParticipantDashboardView from '../pages/meeting-participant/views/dashboard.json';

/** Тип запису «Учасник засідання» зі сторінками пакета: меню, форми та подання з pages/meeting-participant/. */
export const meetingParticipantDefinition: IRecordTypeDefinition = {
  ...meetingParticipantEntity,
  views: assembleViewSet({
      table: meetingParticipantTableView,
      cards: meetingParticipantCardsView,
      calendar: meetingParticipantCalendarView,
      dashboard: meetingParticipantDashboardView,
  }),
  form: meetingParticipantFullForm,
  forms: { full: meetingParticipantFullForm, context: meetingParticipantContextForm, mini: meetingParticipantMiniForm, lookup: meetingParticipantLookupForm },
  menu: meetingParticipantMenu,
} as IRecordTypeDefinition;
